export const photo = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2 5.5L3 4.5H25L26 5.5V22.5L25 23.5H3L2 22.5V5.5ZM4 6.5V18.6667L8 15H9L12.4091 18.125L18 13H19L24 17.5833V6.5H4ZM9.25 13C10.4926 13 11.5 11.9926 11.5 10.75C11.5 9.50736 10.4926 8.5 9.25 8.5C8.00736 8.5 7 9.50736 7 10.75C7 11.9926 8.00736 13 9.25 13Z"
    fill="currentColor"
  />
);
